import "./Daorut.css";
import Nav from "../Nav";
export default function Daorut() {
  const smsMessage = encodeURIComponent(
    "Chào shop, tôi muốn rút tiền thẻ tín dụng, báo phí ưu đãi hôm nay giúp tôi qua zalo: .",
  );
  return (
    <div className="khung">
      <section className="hero">
        <div className="hero-content">
          <h1
            style={{ color: "#0A66E9", fontWeight: "900", textAlign: "center" }}
          >
            DỊCH VỤ RÚT THẺ TP.HCM UY TÍN
          </h1>
          <div className="nd">
            <img className="tick" src="/tick2.svg" alt="tick" />
            <p> Chỉ từ 1,3% — Ưu đãi đang áp dụng số lượng có hạn!</p>
          </div>
          <div className="nd">
            <img className="tick" src="/tick2.svg" alt="tick2" />
            <p>Rút được toàn bộ hạn mức</p>
          </div>
          <div className="nd">
            <img className="tick" src="/tick2.svg" alt="tick3" />
            <p> Đảm bảo uy tín – Quy trình an toàn – Thông tin được bảo vệ</p>
          </div>
          <div className="nd">
            <img className="tick" src="/tick2.svg" alt="tick4" />
            <p>Hỗ trợ mọi lúc – 24/7</p>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <a
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "phone",
                });
              }}
              id="call1"
              className="btn"
              href="tel:0941279829"
            >
              0941 279 829
            </a>
          </div>
        </div>
      </section>
      <div className="body p-2">
        <h2 className="fw-bold" id="tieude">
          Lợi ích khi quẹt thẻ tại chúng tôi - nhận tiền sử dụng nhanh!{" "}
        </h2>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p> Liên hệ 0941 279 829 để được tư vấn ngay lập tức!</p>
            </div>
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p>Phí rút thẻ tín dụng ưu đãi chỉ từ 1,3%</p>
            </div>
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p> Không bị tính phí trong vòng 45 ngày</p>
            </div>
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p>Nhận ngay sau 5-7 phút thủ tục</p>
            </div>
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p>
                Bạn cần rút tiền thẻ tín dụng nhanh – chúng tôi đến phục vụ tại
                chỗ 24/7.
              </p>
            </div>
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p> Giữ kín 100% – An toàn – Tin cậy.</p>
            </div>
            <div className="nd">
              <img className="tick" src="/tick3.svg" alt="tick" />
              <p>Phí rẻ - uy tín - hỗ trợ nhanh - Tại nhà. </p>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <img className="img-fluid w-100" src="826.jpg" alt="pos" />
          </div>
        </div>
      </div>
      <div className="p-2">
        {/* g-3 = khoảng cách; justify-content-center = luôn căn giữa */}
        <div className="row g-3 justify-content-center">
          <h2
            style={{ color: "#0A66E9", textShadow: "0 1px 2px rgba(0,0,0,.6)" }}
            className="pt-3 text-center fw-bold"
          >
            Quy trình làm việc
          </h2>
          {/* Mobile: 1 cột; Tablet: 2 cột; PC: 4 cột */}
          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card-body shadow p-3 w-100 text-center"
              style={{
                background: "#fff",
                color: "#000",
                border: "1px solid #000",
                borderRadius: "1rem",
              }}
            >
              <div className="d-flex justify-content-center gap-1">
                <img style={{ width: "25px" }} src="/1.svg" alt="like" />
                <h3 className="mt-1">BƯỚC 1</h3>
              </div>
              <a
                onClick={() => {
                  window.dataLayer = window.dataLayer || [];

                  window.dataLayer.push({
                    event: "phone",
                  });
                }}
                href="tel:0941 279 829"
                style={{ textDecoration: "none", color: "#000" }}
                className="d-block "
              >
                Gọi hotline 0941 279 829 để thông báo về số tiền cần xử lý.
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card-body shadow p-3 w-100 text-center"
              style={{
                background: "#fff",
                color: "#000",
                border: "1px solid #000",
                borderRadius: "1rem",
              }}
            >
              <div className="d-flex justify-content-center gap-1">
                <img style={{ width: "25px" }} src="/2.svg" alt="like" />
                <h3 className="mt-1">BƯỚC 2</h3>
              </div>
              <p className="d-block">
                Chính chủ chỉ cần mang theo thẻ và CMND. Muốn nhanh hơn? Chúng
                tôi có nhân viên hỗ trợ tận nơi – an toàn, uy tín, xử lý ngay!
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-3 d-flex">
            <div
              className="card-body shadow p-3 w-100 text-center"
              style={{
                background: "#fff",
                color: "#000",
                border: "1px solid #000",
                borderRadius: "1rem",
              }}
            >
              <div className="d-flex justify-content-center gap-1">
                <img style={{ width: "25px" }} src="/3.1.svg" alt="like" />
                <h3 className="mt-1">BƯỚC 3</h3>
              </div>
              <p className="d-block">
                Thanh toán phí rút và kết thúc giao dịch
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-wrap" style={{ backgroundColor: "#1A1D23" }}>
        <div className="container py-3 mb-5">
          {/* Tiêu đề */}
          <div className="d-flex justify-content-center align-items-center gap-2 pb-3">
            <img
              style={{ width: 30, height: 30 }}
              src="/location.svg"
              alt="location"
            />
            <h3 className="fw-bold text-white m-0">
              Văn phòng giao dịch của chúng tôi
            </h3>
          </div>

          {/* 2 cột trên PC, 1 cột ở mobile/tablet */}
          <div className="row g-2 justify-content-center">
            {/* Cột 1: ĐỊA CHỈ */}
            <div className="col-12 col-lg-6">
              <div className="d-flex align-items-start gap-2 item">
                <img style={{ width: 20, height: 20 }} src="/2.svg" alt="" />
                <p className="fw-bold text-white m-0">
                  Cơ sở 1: Khu Phố 3, Xã Tân An Hội, Thành phố Hồ Chí Minh
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img style={{ width: 20, height: 20 }} src="/2.svg" alt="" />
                <p className="fw-bold text-white m-0">
                  Cơ sở 2: Võ Văn Ngân, Phường Thủ Đức, Thành phố Hồ Chí Minh
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img style={{ width: 20, height: 20 }} src="/2.svg" alt="" />
                <p className="fw-bold text-white m-0">
                  Cơ sở 3: Hòa Bình, Phường Tân Phú, Thành phố Hồ Chí Minh
                </p>
              </div>
            </div>

            {/* Cột 2: THÔNG TIN KHÁC */}
            <div className="col-12 col-lg-6">
              <div className="d-flex align-items-start gap-2 item">
                <img style={{ width: 20, height: 20 }} src="/1.svg" alt="" />
                <p className="fw-bold text-white m-0">Hotline: 0941 279 829</p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img
                  style={{ width: 20, height: 20 }}
                  src="/email.svg"
                  alt=""
                />
                <p className="fw-bold text-white m-0">
                  Email: quetthetindunghcm.com@gmail.com
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img style={{ width: 20, height: 20 }} src="/site.svg" alt="" />
                <p className="fw-bold text-white m-0">
                  Website: https://quetthetindunghcm.com
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img style={{ width: 20, height: 20 }} src="/pv.svg" alt="" />
                <p className="fw-bold text-white m-0">Phục vụ 24/7</p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img
                  style={{ width: 20, height: 20 }}
                  src="/security.svg"
                  alt=""
                />
                <p className="fw-bold text-white m-0">Uy tín – Bảo mật</p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img
                  style={{ width: 20, height: 20 }}
                  src="/notebook.svg"
                  alt=""
                />
                <p className="fw-bold text-white m-0">
                  Chi phí thấp nhất thị trường
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 item">
                <img
                  style={{ width: 20, height: 20 }}
                  src="/notebook.svg"
                  alt=""
                />
                <a style={{ textDecoration: "none" }} href="/privacy">
                  <p className="fw-bold text-white m-0">Chính sách bảo mật</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-bar">
        <a
          onClick={() => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: "phone",
            });
          }}
          href="tel:0941279829"
          className="call"
        >
          📞 Gọi ngay
        </a>
        <a
          onClick={() => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: "nt",
            });
          }}
          href={`sms:0941279829?body=${smsMessage}`}
          style={{ backgroundColor: "white", color: "black" }}
          className="sms-pill"
        >
          <span className="sms-pill__text">Nhắn Tin</span>
          <span className="sms-pill__icon">💬</span>
        </a>
      </div>
    </div>
  );
}
